import type { ActionStatus } from '../../../hooks/useVehiclesNavigoMachine/types'

import { useMemo } from 'react'

import { NavigoIconButton } from '@/components/Navigo/elements/NavigoIconButton'
import { Tooltip } from '@/components/primitives/Tooltip'
import { MapStyle } from '@/icons'

import { useTexts } from '../useTexts'

interface Props {
  permission: ActionStatus | 'disabledNoDevice' | 'disabledLoadingGpsData'
  vehicles: uui.domain.client.UnifiedVehicle[]
  testId?: string
  onClick: () => void
}

export function StylerButton(props: Props) {
  const { permission, vehicles, testId, onClick } = props
  const texts = useTexts()

  const disabled = permission.startsWith('disabled')

  const tooltipTitle = useMemo(() => {
    switch (permission) {
      case 'disabledNoDevice':
        return vehicles.length === 1
          ? texts.disabledNoDevice(
              vehicles[0].hasRoutingLicense ? vehicles[0].vehicle.externalId : '',
            )
          : ''

      case 'disabledLoadingGpsData':
        return texts.disabledLoadingGpsData

      case 'disabled':
        return texts.notAvailableInThePast

      default:
        return ''
    }
  }, [texts, permission, vehicles])

  const iconColor = disabled ? '$silver' : '$nightRider'

  return (
    <Tooltip placement="top" disabled={!disabled} title={tooltipTitle}>
      <NavigoIconButton
        Icon={<MapStyle size={20} color={iconColor} />}
        disabled={disabled}
        text={texts.style}
        onClick={onClick}
        testid={testId}
      />
    </Tooltip>
  )
}
